import {cloneDeep} from "lodash";
import React from "react";
import { GelDragDrop } from "@learningblocks/storybook-components";

function filterTrashData(gelTable){
    // Remove the trash can props
    return gelTable.map((col) => {
      return {
        ...col,
        colItems: col.colItems.reduce((filtered, item) => {
          if (item.cellType === "GEL_PATH" && item.cellItems !== null) {
            item.cellItems = item.cellItems.map((band, bandIndex) => {
              band.selected = false;
              return band;
            });
          }
          if (
            item.cellType !== "TRASH_CAN" &&
            item.cellType !== "TRASH_LABEL"
          ) {
            filtered.push(item);
          }
          return filtered;
        }, []),
      };
    });
};

function getLane(type, index, label){
    // Blank lane
    let lane = {
        colId: index + 1,
        colType: "BAND_COLUMN",
        colItems: [
        {
            cellId: 0,
            cellType: "LABEL_CELL",
            label: "",
        },
        {
            cellId: 1,
            cellType: "GEL_HOLDER",
            cellItems: [],
        },
        {
            cellId: 2,
            cellType: "GEL_PATH",
            cellItems: [],
        },
        ],
    };

    switch (type) {
    case "Ladder":
        lane = {
            colId: 1,
            colType: "LADDER_COLUMN",
            colItems: [
            {
                cellId: 0,
                cellType: "LABEL_CELL",
                label: "DNA ladder"
            },
            {
                cellId: 1,
                cellType: "GEL_HOLDER",
                cellItems: []
            },
            {
                cellId: 2,
                cellType: "GEL_PATH",
                cellItems: [
                {
                    gelId: 0,
                    gelType: "FIXED",
                    height: 100,
                    opacity: 1,
                    value: 500,
                    selected: false
                },
                {
                    gelId: 1,
                    gelType: "FIXED",
                    height: 60,
                    opacity: 1,
                    value: 400,
                    selected: false
                },
                {
                    gelId: 2,
                    gelType: "FIXED",
                    height: 60,
                    opacity: 1,
                    value: 300,
                    selected: false
                },
                {
                    gelId: 3,
                    gelType: "FIXED",
                    height: 60,
                    opacity: 1,
                    value: 200,
                    selected: false
                },
                {
                    gelId: 4,
                    gelType: "FIXED",
                    height: 60,
                    opacity: 1,
                    value: 100,
                    selected: false
                }
                ]
            }
            ]
        };
        break;
    case "Single band":
        lane = {
            colId: index + 1,
            colType: "BAND_COLUMN",
            colItems: [
            {
                cellId: 0,
                cellType: "LABEL_CELL",
                label: label,
            },
            {
                cellId: 1,
                cellType: "GEL_HOLDER",
                cellItems: [],
            },
            {
                cellId: 2,
                cellType: "GEL_PATH",
                cellItems: [
                {
                    gelId: 0,
                    gelType: "DRAGGABLE",
                    height: 100,
                    opacity: 1,
                    value: 240,
                    selected: false,
                },
                ],
            },
            ],
        };
        break;
    case "Single band2":
        lane = {
            colId: index + 1,
            colType: "BAND_COLUMN",
            colItems: [
            {
                cellId: 0,
                cellType: "LABEL_CELL",
                label: label,
            },
            {
                cellId: 1,
                cellType: "GEL_HOLDER",
                cellItems: [],
            },
            {
                cellId: 2,
                cellType: "GEL_PATH",
                cellItems: [
                {
                    gelId: 0,
                    gelType: "DRAGGABLE",
                    height: 100,
                    opacity: 1,
                    value: 500,
                    selected: false,
                },
                ],
            },
            ],
        };
        break;
    case "Double band":
        lane = {
            colId: index + 1,
            colType: "BAND_COLUMN",
            colItems: [
            {
                cellId: 0,
                cellType: "LABEL_CELL",
                label: label,
            },
            {
                cellId: 1,
                cellType: "GEL_HOLDER",
                cellItems: [],
            },
            {
                cellId: 2,
                cellType: "GEL_PATH",
                cellItems: [
                {
                    gelId: 0,
                    gelType: "DRAGGABLE",
                    height: 100,
                    opacity: 1,
                    value: 195,
                    selected: false,
                },
                {
                    gelId: 1,
                    gelType: "DRAGGABLE",
                    height: 100,
                    opacity: 1,
                    value: 45,
                    selected: false,
                },
                ],
            },
            ],
        };
        break;
    case "Triple band":
        lane = {
            colId: index + 1,
            colType: "BAND_COLUMN",
            colItems: [
            {
                cellId: 0,
                cellType: "LABEL_CELL",
                label: label,
            },
            {
                cellId: 1,
                cellType: "GEL_HOLDER",
                cellItems: [],
            },
            {
                cellId: 2,
                cellType: "GEL_PATH",
                cellItems: [
                {
                    gelId: 0,
                    gelType: "DRAGGABLE",
                    height: 100,
                    opacity: 1,
                    value: 240,
                    selected: false,
                },
                {
                    gelId: 1,
                    gelType: "DRAGGABLE",
                    height: 100,
                    opacity: 1,
                    value: 195,
                    selected: false,
                },
                {
                    gelId: 2,
                    gelType: "DRAGGABLE",
                    height: 100,
                    opacity: 1,
                    value: 45,
                    selected: false,
                },
                ],
            },
            ],
        };
        break;
    case "Single band dimer":
        lane = {
            colId: index + 1,
            colType: "BAND_COLUMN",
            colItems: [
            {
                cellId: 0,
                cellType: "LABEL_CELL",
                label: label,
            },
            {
                cellId: 1,
                cellType: "GEL_HOLDER",
                cellItems: [],
            },
            {
                cellId: 2,
                cellType: "GEL_PATH",
                cellItems: [
                {
                    gelId: 0,
                    gelType: "DRAGGABLE",
                    height: 100,
                    opacity: 1,
                    value: 250,
                    selected: false,
                },
                {
                    gelId: 1,
                    gelType: "DRAGGABLE",
                    height: 80,
                    opacity: 0.2,
                    value: 80,
                    selected: false,
                },
                ],
            },
            ],
        };
        break;
    case "Double band dimer":
        lane = {
            colId: index + 1,
            colType: "BAND_COLUMN",
            colItems: [
            {
                cellId: 0,
                cellType: "LABEL_CELL",
                label: label,
            },
            {
                cellId: 1,
                cellType: "GEL_HOLDER",
                cellItems: [],
            },
            {
                cellId: 2,
                cellType: "GEL_PATH",
                cellItems: [
                {
                    gelId: 0,
                    gelType: "DRAGGABLE",
                    height: 80,
                    opacity: 0.8,
                    value: 150,
                    selected: false,
                },
                {
                    gelId: 1,
                    gelType: "DRAGGABLE",
                    height: 80,
                    opacity: 0.8,
                    value: 90,
                    selected: false,
                },
                {
                    gelId: 2,
                    gelType: "DRAGGABLE",
                    height: 80,
                    opacity: 0.2,
                    value: 80,
                    selected: false,
                },
                ],
            },
            ],
        };
        break;
    case "Triple band dimer":
        lane = {
            colId: index + 1,
            colType: "BAND_COLUMN",
            colItems: [
            {
                cellId: 0,
                cellType: "LABEL_CELL",
                label: label,
            },
            {
                cellId: 1,
                cellType: "GEL_HOLDER",
                cellItems: [],
            },
            {
                cellId: 2,
                cellType: "GEL_PATH",
                cellItems: [
                {
                    gelId: 0,
                    gelType: "DRAGGABLE",
                    height: 100,
                    opacity: 0.8,
                    value: 250,
                    selected: false,
                },
                {
                    gelId: 1,
                    gelType: "DRAGGABLE",
                    height: 80,
                    opacity: 0.5,
                    value: 150,
                    selected: false,
                },
                {
                    gelId: 2,
                    gelType: "DRAGGABLE",
                    height: 80,
                    opacity: 0.5,
                    value: 90,
                    selected: false,
                },
                {
                    gelId: 3,
                    gelType: "DRAGGABLE",
                    height: 80,
                    opacity: 0.2,
                    value: 80,
                    selected: false,
                },
                ],
            },
            ],
        };
        break;
    case "No band":
        lane = {
            colId: index + 1,
            colType: "BAND_COLUMN",
            colItems: [
            {
                cellId: 0,
                cellType: "LABEL_CELL",
                label: label,
            },
            {
                cellId: 1,
                cellType: "GEL_HOLDER",
                cellItems: [],
            },
            {
                cellId: 2,
                cellType: "GEL_PATH",
                cellItems: [],
            },
            ],
        };
        break;
    default:
    // code block
}

return lane;
};

function hasSolution(solutions, expectedSol){
let hasAllSoloutions = true
for(let i in expectedSol){
    if(!solutions[i]){
    hasAllSoloutions = false
    }
}
console.log(hasAllSoloutions)
return hasAllSoloutions
}
export function getActualGel(gelExamined, gelOrientation, actualData, level, interactionProps) {
    let data = cloneDeep(actualData);
    const lanes = interactionProps.agaroseGel[0].lanes
    //const solution = interactionProps.solutions[7];

    //Add band items in the actual gel
    Object.keys(lanes).forEach(
        (lane, index) => {

        const solutionAlias = lanes[lane].solutionAlias
        const solution = lanes[lane].solutions

        /**
         * gel orientation
         * forgot to add restriction enzyme to samples
         * 
         */

        // skip lane 6, 7 and 8 to keep it 5 lanes
        if (['lane6', 'lane7', 'lane8'].includes(lane)) { return }

        if (gelOrientation === 180) {
        // if (true) {
            if (solution.hasOwnProperty("DNA ladder (L)")) {
                addLane(data, index, 'Ladder', "Ladder");
            }
            else if (solution.hasOwnProperty("DNA A") || solution.hasOwnProperty("DNA B") || solution.hasOwnProperty("DNA C")) {
            let expectedSol = { "HaeIII (RE)": 0.2, "Loading dye (LD)": 0.2}
            
            if(hasSolution(solution, expectedSol)){
                if(solution['DNA A'] > 1){
                    addLane(data, index, 'S+', "Double band");
                } else if(solution['DNA B'] > 1){
                    addLane(data, index, 'S+', "Triple band");
                } else if(solution['DNA C'] > 1){
                    addLane(data, index, 'S+', "Single band");
                }
            } else {
                addLane(data, index, 'S+', "Single band");
            }
            }
            else if (solution.hasOwnProperty("BB positive control")) {
                let expectedSol = { "HaeIII (RE)": 0.2, "BB positive control": 0.2, "Loading dye (LD)": 0.2}
                if(hasSolution(solution, expectedSol)){
                    addLane(data, index, '<i>BB<i>+', "Double band");
                } else {
                    addLane(data, index, '<i>BB<i>+', "Single band");
                }
            }
            else if (solution.hasOwnProperty('Bb positive control')) {
                let expectedSol = { "HaeIII (RE)": 0.2, "Bb positive control": 0.2, "Loading dye (LD)": 0.2}
                if(hasSolution(solution, expectedSol)){
                    addLane(data, index, '<i>Bb</i>+', "Triple band");
                } else {
                    addLane(data, index, '<i>Bb</i>+', "Single band");
                }
            }
            else if (solution.hasOwnProperty('bb positive control')) {
                let expectedSol = { "HaeIII (RE)": 0.2, "bb positive control": 0.2, "Loading dye (LD)": 0.2}
                if(hasSolution(solution, expectedSol)){
                    addLane(data, index, '<i>bb</i>+', "Single band");
                } else  {
                    addLane(data, index, '<i>bb</i>+', "Single band");
                }
            }
            else {
                addLane(data, index, solutionAlias, "");
            }
        } else {
                addLane(data, index, solutionAlias, "");
        }
     }
);

return (
    <GelDragDrop
    useAbbrevLabel={true}
    id={data.id}
    type={data.type}
    gelTheme={data.gelTheme}
    title={data.title}
    heading={data.heading}
    text={data.text}
    gelRange={data.gelRange}
    content={data.content}
    gelTable={data.gelTable}
    />
);
};
export function getActualGel2(gelExamined, gelOrientation, actualData, level, interactionProps) {
let data = cloneDeep(actualData);

console.log('level is : ', level);

//Add band items in the actual gel
Object.keys(interactionProps.agaroseGel[0].lanes).forEach(
    (lane, index) => {
    console.log('lane and index');
    console.log({ lane, index });
    // if (gelOrientation === 180) {
    if (['lane7', 'lane8'].includes(lane)) { return }
    if (true) {
        if (
        interactionProps.agaroseGel[0].lanes[lane]
            .solutionAlias === "DNA ladder (M)" ||
        interactionProps.agaroseGel[0].lanes[lane]
            .solutionAlias === "DNA ladder (M)"
        ) {
        data.gelTable.push(getLane("Ladder", index, interactionProps.agaroseGel[0].lanes[lane].solutionAlias));
        } else if (
        interactionProps.agaroseGel[0].lanes[lane]
            .solutionAlias === "Gel sample 1 - unknown" ||
        interactionProps.agaroseGel[0].lanes[lane]
            .solutionAlias === "Gel positive control - known DD"
        ) {
        data.gelTable.push(getLane("Single band", index, interactionProps.agaroseGel[0].lanes[lane].solutionAlias));
        } else if (
        [
            // 'Gel positive control - known II',
            'Gel positive control - known ID'
        ].includes(interactionProps.agaroseGel[0].lanes[lane]
            .solutionAlias)
        ) {
        data.gelTable.push(getLane("Double band", index, interactionProps.agaroseGel[0].lanes[lane].solutionAlias));
        } else if (
        [
            'Gel positive control - known II',
            // 'Gel positive control - known ID'
        ].includes(interactionProps.agaroseGel[0].lanes[lane]
            .solutionAlias)
        ) {
        data.gelTable.push(getLane("Single band2", index, interactionProps.agaroseGel[0].lanes[lane].solutionAlias));
        } else {
        data.gelTable.push(getLane("", index, interactionProps.agaroseGel[0].lanes[lane].solutionAlias));
        }
    } else {
        data.gelTable.push(getLane("", index, interactionProps.agaroseGel[0].lanes[lane].solutionAlias));
    }
    }
);

return (
    <GelDragDrop
    useAbbrevLabel={true}
    id={data.id}
    type={data.type}
    gelTheme={data.gelTheme}
    title={data.title}
    heading={data.heading}
    text={data.text}
    gelRange={data.gelRange}
    content={data.content}
    gelTable={data.gelTable}
    />
);
};
export function getPredictedGel(prediction) {
let data = cloneDeep(prediction);
data.gelTable = filterTrashData(data.gelTable);

data.gelTable = data.gelTable.map((col) => {
    // Remove the gel_holder items
    if(col.colItems[1].cellType === "GEL_HOLDER" && col.colItems[1].cellItems !== null && col.colItems[1].cellItems.length > 0){
        if(col.colItems[2].cellType === "GEL_PATH"){
            col.colItems[1].cellItems = [];
        }
    }
    return col;
});

return (
    <GelDragDrop
    useAbbrevLabel={true}
    id={data.id}
    type={data.type}
    gelTheme={data.gelTheme}
    title={data.title}
    heading={data.heading}
    text={data.text}
    gelRange={data.gelRange}
    content={data.content}
    gelTable={data.gelTable}
    />
);
};
export function getIdealGel(data, interactionProps) {
let idealData = {
    "DNA A": {
    "S+": [
        195,
        45,
        0
    ]
    },
    "DNA B": {
    "S+": [
        240,
        195,
        45
    ]
    },
    "DNA C": {
    "S+": [
        240,
        0,
        0
    ]
    }
}

data.gelTable = data.gelTable.map((col) => {

    // Rearrange the gel_holder and gel_path props
    if(col.colItems[1].cellType === "GEL_HOLDER" && col.colItems[1].cellItems !== null && col.colItems[1].cellItems.length > 0){
    if(col.colItems[2].cellType === "GEL_PATH"){
        col.colItems[2].cellItems = col.colItems[1].cellItems;
        col.colItems[1].cellItems = [];
    }
    }

    // Insert the Ideal values
    col.colItems = col.colItems.map((item) => {
        if(item.cellType === "GEL_PATH" && item.cellItems !== null){
        item.cellItems = item.cellItems.filter((band, bandIndex)=>{
            let key = Object.keys(interactionProps.solutions[7].solutions)[0];
            let unknownSampleLabel = col.colItems[0].label;

            if(idealData[key].hasOwnProperty(unknownSampleLabel)){
            band.value = idealData[key][unknownSampleLabel][bandIndex];
            if(key === 'DNA B'){
                band.height = 100
            }
            if(key === 'DNA C'){
                band.height = 100
            }
            if(key === 'DNA A'){
                band.height = 100
            }
            }
            if(band.value !== 0){
            return band;
            }
        })
        }
        return item;
    });
    return col;
});

return (
    <GelDragDrop
    useAbbrevLabel={true}
    id={data.id}
    type={data.type}
    gelTheme={data.gelTheme}
    title={data.title}
    heading={data.heading}
    text={data.text}
    gelRange={data.gelRange}
    content={data.content}
    gelTable={data.gelTable}
    />
);
};

function addLane(data, index, solutionAlias, bandType) {
    data.gelTable.push(getLane(bandType, index, solutionAlias));
}